module.exports = __webpack_public_path__ + "static/img/caa-text.922db16c.png";